import axios from 'axios';
import { FC, useEffect, useLayoutEffect, useState } from 'react';
import { Setting, statusMessages, Subscription } from '../App';
import { CUSTOMER_API_URL } from '../constants';
import style from '../styles/SubscriptionList.module.css';
import SubscriptionItem from './SubscriptionItem';

export type StatusMessage = keyof typeof statusMessages;

export const SubscriptionList: FC<{ setting: Setting }> = ({ setting }) => {
  const [subscriptions, setSubscriptions] = useState<Subscription[]>([]);

  useEffect(() => {
    window.parent.postMessage({ action: 'subscriptionList' }, '*');

    axios
      .post(`${CUSTOMER_API_URL}?action=getSubscriptions`, {}, { headers: { Authorization: setting.token } })
      .then((response) => {
        setSubscriptions(response.data);
      });
  }, []);

  useLayoutEffect(() => {
    const height = document.querySelector('body')!.scrollHeight + 15; // buffer;

    setting.resize(height);
    window.parent.postMessage({ action: 'subscriptionList' }, '*');
  }, [subscriptions]);

  console.log('subscriptions', subscriptions);

  const activeSubscriptions = subscriptions.filter((subscription) => subscription.status !== 'CANCELLED');

  console.log('subscriptionLength', activeSubscriptions.length);

  return (
    <>
      <div className={style.subscriptionList}>
        <div className={style.subscriptionListBody}>
          {activeSubscriptions.length > 0 ? (
            activeSubscriptions.map((subscription, index) => (
              <SubscriptionItem
                key={`${subscription.subscriptionContractId}_${index}`}
                subscriptionContractId={subscription.subscriptionContractId}
                setting={setting}
                last={activeSubscriptions.length === index + 1}
              />
            ))
          ) : (
            <div className={style.subscriptionListEmpty}>
              <p>現在ご利用の定期便はありません。</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};
